import React from "react";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { Title } from "./styles";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  dataUser: {
    color: "#0033C6",
  },
}));

interface IPageTitle {
  title: string;
  userName: string;
}

const PageTitle: React.FC<IPageTitle> = ({ title, userName }) => {
  const classes = useStyles();
  return (
    <div className="flex justify-between w-full items-center flex-wrap">
      <Title>{title}</Title>
      <h4 className={`flex items-center gap-1 ${classes.dataUser}`}>
        <AccountCircleIcon fontSize="large" />
        {userName}
      </h4>
    </div>
  );
};

export default PageTitle;
